import PropTypes from 'prop-types';

import PropTypesPresenter from '../../utils/PropTypesPresenter';
import DatePresenter from '../../presenters/DatePresenter';

const ACTIVE_MEMBERSHIP_CREATED = 'active_membership_created';
const PENDING_MEMBERSHIP_CREATED = 'pending_membership_created';
const MEMBERSHIP_ACTIVATED = 'memership_activated';
const MEMBERSHIP_REACTIVATED = 'membership_reactivated';
const MEMBERSHIP_CANCELED = 'membership_canceled';
const MEMBERSHIP_ARCHIVED = 'membership_archived';

export default new PropTypesPresenter(
  {
    id: PropTypes.string,
    eventType: PropTypes.string,
    createdAt: PropTypes.string,
  },
  {
    createdAtReadable(log) {
      const createdAt = this.createdAt(log);
      return DatePresenter.shortFormattedDate(createdAt);
    },
    eventTypeReadable(log) {
      const eventMap = {
        [ACTIVE_MEMBERSHIP_CREATED]: 'Active Membership Created',
        [PENDING_MEMBERSHIP_CREATED]: 'Pending Membership Created',
        [MEMBERSHIP_ACTIVATED]: 'Membership Activated',
        [MEMBERSHIP_REACTIVATED]: 'Membership Reactivated',
        [MEMBERSHIP_CANCELED]: 'Membership Canceled',
        [MEMBERSHIP_ARCHIVED]: 'Membership Archived',
      };
      const type = this.eventType(log);

      return eventMap[type];
    },
  }
);
